// Cart stepper UX overlay
// SCOPE: alleen op cart-context (cart-page + cart-drawer) waar de buttons <a href="/cart/change?...">
// zijn. NIET op PDP — daar handelt Prestige's quantity-input zelf de increment.

(function () {
  'use strict';

  const pendingTimers = new WeakMap();

  function isCartContextButton(button) {
    // Cart buttons zijn <a href="/cart/change?line=X&quantity=Y"> (Shopify no-JS fallback)
    // PDP buttons zijn <button> zonder href.
    if (button.tagName.toLowerCase() !== 'a') return false;
    const href = button.getAttribute('href') || '';
    return href.includes('/cart/change') || href.includes('/cart/update');
  }

  function handleStepClick(e) {
    const button = e.target.closest('.quantity-selector__button');
    if (!button) return;

    // CRITICAL: alleen optimistic update voor cart-context. Skip op PDP.
    if (!isCartContextButton(button)) return;

    const selector = button.closest('quantity-selector');
    if (!selector) return;

    const input = selector.querySelector('input[type="number"]');
    if (!input) return;

    // Bepaal richting via positie (eerste = min, laatste = plus)
    const buttons = selector.querySelectorAll('.quantity-selector__button');
    const isPlus = button === buttons[buttons.length - 1];

    const current = parseInt(input.value, 10) || 1;
    const max = parseInt(input.max, 10) || 999;
    const next = isPlus
      ? Math.min(current + 1, max)
      : Math.max(current - 1, 1);

    if (next !== current) {
      input.value = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    selector.classList.add('is-syncing');

    clearTimeout(pendingTimers.get(selector));
    pendingTimers.set(
      selector,
      setTimeout(() => selector.classList.remove('is-syncing'), 700)
    );
  }

  document.addEventListener('click', handleStepClick, true);
})();